import Cookies from 'js-cookie';
import themeConfig from "../../../themeConfig";
import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList";
import colors from "../../../themeConfig";
import user from "@/store/modules/user";
/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const frame = {
  state: {
    // 框架内的 start todo
    bodyOverlay: false,
    isVerticalNavMenuActive: true,
    // mainLayoutType: themeConfig.mainLayoutType || "vertical",
    mainLayoutType: "vertical",
    navbarSearchAndPinList: navbarSearchAndPinList,
    reduceButton: themeConfig.sidebarCollapsed,
    verticalNavMenuWidth: "default",
    verticalNavMenuItemsMin: false,
    scrollY: 0,
    starredPages: navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme: themeConfig.theme || "light",
    themePrimaryColor: colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
    // language:  Cookie.get('language') || 'zh_CN',
    // 框架内的end
  },
  mutations: {
    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu

    TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
      state.isVerticalNavMenuActive = value
    },
    TOGGLE_REDUCE_BUTTON(state, val) {
      state.reduceButton = val
    },
    UPDATE_MAIN_LAYOUT_TYPE(state, val) {
      state.mainLayoutType = val
    },
    UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
      state.verticalNavMenuItemsMin = val
    },
    UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
      state.verticalNavMenuWidth = width
    },


    // VxAutoSuggest

    UPDATE_STARRED_PAGE(state, payload) {

      // find item index in search list state
      const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

      // update the main list
      state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

      // if val is true add it to starred else remove
      if (payload.val) {
        state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
      } else {
        // find item index from starred pages
        const index = state.starredPages.findIndex((item) => item.url == payload.url)

        // remove item using index
        state.starredPages.splice(index, 1)
      }
    },

    // Navbar-Vertical

    ARRANGE_STARRED_PAGES_LIMITED(state, list) {
      const starredPagesMore = state.starredPages.slice(10)
      state.starredPages = list.concat(starredPagesMore)
    },
    ARRANGE_STARRED_PAGES_MORE(state, list) {
      let downToUp = false
      let lastItemInStarredLimited = state.starredPages[10]
      const starredPagesLimited = state.starredPages.slice(0, 10)
      state.starredPages = starredPagesLimited.concat(list)

      state.starredPages.slice(0, 10).map((i) => {
        if (list.indexOf(i) > -1) downToUp = true
      })

      if (!downToUp) {
        state.starredPages.splice(10, 0, lastItemInStarredLimited)
      }
    },


    // ////////////////////////////////////////////
    // UI
    // ////////////////////////////////////////////

    TOGGLE_CONTENT_OVERLAY(state, val) {
      state.bodyOverlay = val
    },
    UPDATE_PRIMARY_COLOR(state, val) {
      state.themePrimaryColor = val
    },
    UPDATE_THEME(state, val) {
      state.theme = val
    },
    UPDATE_WINDOW_WIDTH(state, width) {
      state.windowWidth = width
    },
    UPDATE_WINDOW_SCROLL_Y(state, val) {
      state.scrollY = val
    },
  },
  actions: {
    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },
  },
  getters: {
    windowBreakPoint: state => {

      // This should be same as tailwind. So, it stays in sync with tailwind utility classes
      if (state.windowWidth >= 1200) return "xl"
      else if (state.windowWidth >= 992) return "lg"
      else if (state.windowWidth >= 768) return "md"
      else if (state.windowWidth >= 576) return "sm"
      else return "xs"
    },
    isVerticalNavMenuActive: state => state.isVerticalNavMenuActive,
    bodyOverlay: state => state.bodyOverlay,
    mainLayoutType: state => state.mainLayoutType,
    navbarSearchAndPinList: state => state.navbarSearchAndPinList,
    reduceButton: state => state.reduceButton,
    verticalNavMenuWidth: state => state.verticalNavMenuWidth,
    verticalNavMenuItemsMin: state => state.verticalNavMenuItemsMin,
    scrollY: state => state.scrollY,
    starredPages: state => state.starredPages,
    theme: state => state.theme,
    themePrimaryColor: state => state.themePrimaryColor,
    windowWidth: state => state.windowWidth,
  }
}

export default frame;
